import React, { useState } from "react";
import { Avatar, Popover } from "antd";
import { momentit } from "../../../utils";
import { ReactComponent as ViewIcon } from "../../../Icons/totalView.svg";
import { ReactComponent as ImageIcon } from "../../../Icons/image.svg";
import { ReactComponent as EmailIcon } from "../../../Icons/email.svg";
import { useSelector } from "react-redux";
import { ReactComponent as PdfWhiteIcon } from "../../../Icons/pdfWhiteIcon.svg";
import { markUnmarkFavourite } from "../../../API/api";
import { ReactComponent as ThreadIcon } from "../../../Icons/thread.svg";
import { ReactComponent as DownloadIcon } from "../../../Icons/download.svg";
import Button2 from "../../Button2/Button2";
import AttachmentBox from "../../AttachmentBox/AttachmentBox";
import TooltipComp from "../../ToolTip/TooltipComp";
import { ReactComponent as VideoIcon } from "../../../Icons/video.svg";
import { ReactComponent as URLIcon } from "../../../Icons/crawl.svg";
import { ReactComponent as InternalIcon } from "../../../Icons/internal.svg";

export default function NameInfo({ data, question }) {
  const searchState = useSelector((state) => state.search);
  const [isFavorite, setFavorite] = useState(question.favourite);
  const onCLickFavorite = (key, flag) => {
    // markUnmarkFavourite(key.questionUuid).then((res) => {
    //   if (res === undefined) return;
    //   setFavorite(flag);
    // });
  };
  const userProfile = () => {
    let img = "";
    img = searchState.usersProfilePicData.find(
      (obj) => obj.uuid === data.expertUuid
    );
    if (img !== undefined) {
      return `data:image/JPEG;base64,${img.img}`;
    }
  };
  userProfile();
  const infoContainer = {
    display: "flex",
    alignItems: "center",
  };
  const dateInfoStyles = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: "7px",
  };
  const textStyles = {
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "24px",
    fontWeight: "400",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const dateStyles = {
    fontSize: "13px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "300",
  };
  const confidenceStyles1 = {
    // width:'52px',
    height: "36px",
    border: "1px solid #F59B00",
    borderRadius: "6px",
    backgroundColor: "#F59B00",
    color: "#FFFFFF",
    lineHeight: "24px",
    fontSize: "14px",
    fontWeight: "500",
    padding: "6px 12px 6px 12px",
  };
  const confidenceStyles2 = {
    // width:'52px',
    height: "36px",
    border: "1px solid #00A3FF",
    borderRadius: "6px",
    backgroundColor: "#00A3FF",
    color: "#FFFFFF",
    lineHeight: "24px",
    fontSize: "14px",
    fontWeight: "500",
    padding: "6px 12px 6px 12px",
  };
  const textStyles2 = {
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "24px",
    fontWeight: "400",
    wordBreak: 'break-word',overflowWrap: 'break-word',
    background:
      "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
    "-moz-text-fill-color": "transparent",
    "-ms-text-fill-color": "transparent",
    "-o-text-fill-color": "transparent",
  };
  const renderAttachemnt = (arr) => {
    return (
      <div className="mb-1">
          {arr.map((item, index) => (
            <div>
              {" "}
              <AttachmentBox key={index} attachment={item} />
            </div>
          ))}
      </div>
    );
  };
  return (
    <>
      <div style={infoContainer}>
        <div>
            <Avatar
              size={48}
              src={require("../../../Images/bot-icon.png")}
            ></Avatar>
        </div>
        <div style={dateInfoStyles}>
          <div>
            {question.docType !== "urlcrawl" && question.docType !== "Thread" && (
              <div style={textStyles}>
                {question.docName === "" || question.docName === undefined
                  ? question.docType === "Email"?`${question.emailAliases[0]}`:`${question.source===undefined? `${data.expert.firstName} ${data.expert.lastName}`:question.source}`
                  : question.docType === 'Pdf'&& question.url !== undefined ? (
                    <div style={textStyles2}><a style={{color:'#2a364a'}} href={question.url} target="_blank">{question.url}</a>&nbsp;<span >{`${question.source===undefined?"":"("+question.source+")"}`}</span></div>
                  ):<div style={textStyles} >{question.docName}</div>}
              </div>
            )}
            {/* {question.docType === 'Pdf'&& question.url !== undefined ? (
                  <div style={textStyles2}><a style={{color:'#2a364a'}} href={question.url} target="_blank">{question.url}</a>&nbsp;<span >{`${question.source===undefined?"":"("+question.source+")"}`}</span></div>
                ):<div style={textStyles} >{question.docName}</div>} */}
{question.docType === "Thread" && (
              <div style={textStyles}>
                {question.source} {question.channelName !== undefined && question.channelName !== '' && `(${question.channelName})`}
              </div>
            )}
             {question.docType === 'urlcrawl'   && (
                  <div style={textStyles2}><a style={{color:'#2a364a'}} href={question.url} target="_blank">{question.url}</a>&nbsp;<span >{`${question.source===undefined?"":"("+question.source+")"}`}</span></div>
                )}
            <div style={dateStyles}>
              {data.answeredTimestamp < data.lastUpdatedTimestamp
                ? "Last reviewed"
                : "Answered"}
              &nbsp;
              {momentit(
                data.answeredTimestamp < data.lastUpdatedTimestamp
                  ? data.lastUpdatedTimestamp
                  : data.answeredTimestamp
              )}
            </div>
          </div>
          <div style={infoContainer}>
            {data.popularityScore !== null &&
              data.popularityScore !== undefined && (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    lineHeight: "24px",
                    color: "#5C667B",
                    // fontWeight: "500",
                  }}
                >
                  
                  <TooltipComp title={"Total view count"}>
                                    <ViewIcon /> 
                                  </TooltipComp>
                  &nbsp;{data.popularityScore}&nbsp;&nbsp;
                </span>
              )}
              { question.usageAccess === "internal"  && (
              <div style={{ marginRight: "6px" }}>
                <TooltipComp title={"Internal Answer"}>
                                  <InternalIcon /> 
                                </TooltipComp>
              </div>
            )}
            {(question.docType !== "Thread" &&  question.docType !== "Email" && question.docType !== "urlcrawl") && (question.docType === 'Pdf'&& question.url === undefined )&& data.attachments !== null && 
              data.attachments &&
              data.attachments.length > 0 && (
                <div style={{ marginRight: "6px" }}>
                  <Popover title={renderAttachemnt(data.attachments)}>
                    {" "}
                    <Button2 onClickFunc={onCLickFavorite}>
                      <DownloadIcon />
                    </Button2>
                  </Popover>
                </div>
              )}
            <div
              style={
                question.confidence ? confidenceStyles2 : confidenceStyles1
              }
            >
              {question.docType === "Image"  &&<ImageIcon style={{ marginBottom: "4px" }} /> }
              {question.docType === "Email"  &&<EmailIcon style={{ marginBottom: "4px" }} /> }
              {question.docType === "Thread"  &&<ThreadIcon style={{ marginBottom: "4px" }} /> }
              {question.docType === "Pdf"  &&<PdfWhiteIcon style={{ marginBottom: "4px" }} /> }
              {question.docType === "Video"  &&<VideoIcon style={{ marginBottom: "4px" }} /> }
              {question.docType === "urlcrawl"  &&<URLIcon style={{ marginBottom: "4px" }} /> }

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
